import { FC, useState } from 'react';
import { Button, CustomInput } from 'reactstrap';
import { PROFIMEX_ID } from 'src/types.d';
import I18n from '../I18n/I18n';
import { OperatorBoxDisplay } from '../SelectOperatorComponent/SelectOperatorComponent';
import { ContentWrapper, ErrorMessageStyle, StyledTerms } from './StyledTerms';

type Props = {
  onUserAgreed: (termsAgreed: boolean, marketingAgreed: boolean) => void;
  isFailed?: boolean;
  operators?: OperatorBoxDisplay[];
};

const Terms: FC<Props> = props => {
  const { onUserAgreed, isFailed, operators } = props;
  const [termsAgreed, setTermsAgreed] = useState<boolean>(true);
  const [marketingAgreed, setMarketingAgreed] = useState<boolean>(false);
  const termsLink = process.env.REACT_APP_TERMS_AGREEMENT_URL;

  //set whether this is a profimex user
  const isProfimex: boolean =
    operators?.find((operator: OperatorBoxDisplay) => operator.id === PROFIMEX_ID) !== undefined;

  const onChangeHandler = event => {
    const { name, checked } = event.target;
    const dict = {
      termsAgreed: () => setTermsAgreed(checked),
      marketingAgreed: () => setMarketingAgreed(checked),
    };
    dict[name]();
  };

  return (
    <StyledTerms>
      <ContentWrapper>
        <I18n element="h4">termsAgreement.termsTitle</I18n>
        <div className="mt-3">
          <CustomInput
            type="checkbox"
            id="termsAgreed"
            name="termsAgreed"
            label={
              <span>
                <I18n>termsAgreement.termsLabel</I18n>
                <I18n
                  element="a"
                  elementProps={{ href: termsLink, target: '_blank' }}
                  className="document_link"
                >
                  termsAgreement.termsLabelLink
                </I18n>
                &nbsp;and&nbsp;
                <I18n
                  element="a"
                  elementProps={{
                    href: process.env.REACT_APP_PRIVACY_POLICY_URL,
                    target: '_blank',
                  }}
                  className="document_link"
                >
                  termsAgreement.privacyLabelLink
                </I18n>
              </span>
            }
            onChange={onChangeHandler}
            checked={termsAgreed}
          />
          {/* Don't show marketing option for Profimex users */}
          {!isProfimex && (
            <CustomInput
              type="checkbox"
              id="marketingAgreed"
              name="marketingAgreed"
              label={<I18n>termsAgreement.marketingLabel</I18n>}
              onChange={onChangeHandler}
              checked={marketingAgreed}
            />
          )}
        </div>
        <Button
          disabled={!termsAgreed}
          color={termsAgreed ? 'primary' : 'lightGray'}
          className="mt-3"
          onClick={() => onUserAgreed(termsAgreed, marketingAgreed)}
          style={{ textTransform: 'capitalize' }}
        >
          <I18n>termsAgreement.btnLabel</I18n>
        </Button>
        {isFailed && (
          <ErrorMessageStyle>
            <I18n>termsAgreement.errorLabel</I18n>
          </ErrorMessageStyle>
        )}
      </ContentWrapper>
    </StyledTerms>
  );
};

export default Terms;
